import { defineStore } from 'pinia'

import type { FeatureTourStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useFeatureTourStore = defineStore('feature-tour', {
  state: (): FeatureTourStore => ({
    activeTourId: null,
    currentStepIndex: 0,
    isActive: false,
    isVisible: false,
    activeTour: null,
    spotRegistry: new Map(),
  }),
  actions,
  getters,
})
